export default [
  {
    title: 'Продукт',
    value: 'product'
  }
]